import { PERMISSIONS } from 'shared-permissions';
const {
  SHOWS,
  SHOW_STATS,
  MANAGE_OWN_SHOWS,
  MODERATE,
  LANGUAGE,
  INTEGRATIONS_ONE_TO_MANY,
  EDIT_USERS_ONE_TO_MANY,
  DATA_EXPORT_SERVICE_EXPORT_JOBS,
  MANAGE_AI_GROUNDINGS,
  WORKSPACE_SETTINGS,
  LOCALIZATION_ONE_TO_MANY,
} = PERMISSIONS;
import {
  ORG_INTEGRATIONS,
  ORG_MODULES,
  ORG_FLOATING_WIDGET,
  ORG_SHOWS,
  ORG_STATS,
  ORG_THEMES,
  ORG_LOCALIZATION,
  ORG_USERS,
  ORG_DATA_REPORTS,
  ORG_ONE_TO_MANY_HOME,
  ORG_ONE_TO_MANY_THEMES,
  ORG_EMBED_STATS,
  ORG_ONE_TO_MANY_AI,
  ORG_GENERAL_SETTINGS,
  ORG_DATA_EXPORT_JOBS,
  ORG_LIVE_PRODUCTS,
} from 'constants/routes.js';
import { playerV2Filter } from './utils.js';

const ONE_TO_MANY_ROUTES = [
  {
    title: 'sidebarComponent.homeTitle',
    icon: 'home',
    route: ORG_ONE_TO_MANY_HOME,
    dataTestId: 'homeMenuItem',
    requiredFeatures: [],
    requiredPermission: [MANAGE_OWN_SHOWS, SHOWS, MODERATE],
    allowSuperAdmin: true,
    exact: true,
    shownInMasquerade: false,
  },
  {
    title: 'sidebarComponent.showsTitle',
    icon: 'shows',
    route: ORG_SHOWS,
    dataTestId: 'showsMenuItem',
    requiredFeatures: ['showsEnabled'],
    requiredPermission: [MANAGE_OWN_SHOWS, SHOWS, MODERATE],
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.productsTitle',
    icon: 'bag',
    route: ORG_LIVE_PRODUCTS,
    requiredFeatures: ['productCatalogProductsLiveEnabled'],
    requiredPermission: [MANAGE_OWN_SHOWS, SHOWS, MODERATE],
    dataTestId: 'productsMenuItem',
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.statsTitle',
    icon: 'insights',
    submenu: [
      {
        title: 'sidebarComponent.statsEmbedTitle',
        route: ORG_EMBED_STATS,
        requiredFeatures: ['showsEnabled', 'showStatsEmbedEnabled'],
        requiredPermission: [SHOW_STATS],
        allowSuperAdmin: true,
        exact: true,
        flair: {
          id: 'sidebarFlair-sub-menu-insights',
        },
      },
      {
        title: 'showStatsPageTabs.tabTitleShowsList',
        route: ORG_STATS,
        routeParams: { pageName: 'showsList' },
        requiredFeatures: ['showsEnabled'],
        allowSuperAdmin: true,
        requiredPermission: [SHOW_STATS, MANAGE_OWN_SHOWS],
        flair: {
          id: 'sidebarFlair-sub-menu-showsList',
        },
      },
      {
        title: 'showStatsPageTabs.tabTitleSummary',
        route: ORG_STATS,
        routeParams: { pageName: 'summary' },
        requiredFeatures: ['showsEnabled', 'legacyStatsEnabled'],
        allowSuperAdmin: true,
        requiredPermission: [SHOW_STATS],
        shownInMasquerade: false,
      },
      {
        title: 'showStatsPageTabs.tabTitleDataDispatch',
        route: ORG_DATA_REPORTS,
        requiredFeatures: ['showsEnabled', 'showStatsDataReportsEnabled'],
        allowSuperAdmin: true,
        requiredPermission: [DATA_EXPORT_SERVICE_EXPORT_JOBS],
      },
      {
        title: 'sidebarComponent.dataExportJobsTitle',
        route: ORG_DATA_EXPORT_JOBS,
        requiredFeatures: ['showsEnabled', 'dataExportEnabled'],
        allowSuperAdmin: true,
        requiredPermission: [SHOW_STATS],
      },
    ],
  },
  {
    title: 'sidebarComponent.widgetTitle',
    icon: 'widgets',
    submenu: [
      {
        title: 'sidebarComponent.channelsTitle',
        route: ORG_MODULES,
        requiredFeatures: ['showsEnabled', 'modulesEnabled'],
        requiredPermission: SHOWS,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.floatingActionsTitle',
        route: ORG_FLOATING_WIDGET,
        requiredFeatures: ['showsEnabled', 'widgetsEnabled'],
        requiredPermission: SHOWS,
        allowSuperAdmin: true,
      },
    ],
  },
  {
    title: 'sidebarComponent.aiGroundingsModerationTitle',
    icon: 'ai',
    route: ORG_ONE_TO_MANY_AI,
    dataTestId: 'AIGroundingsModerationMenuItem',
    requiredFeatures: ['AIGroundingsModerationEnabled'],
    requiredPermission: MANAGE_AI_GROUNDINGS,
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.settingsTitle',
    icon: 'settings',
    align: 'bottom',
    submenu: [
      {
        title: 'sidebarComponent.generalSettingsTitle',
        route: ORG_GENERAL_SETTINGS,
        requiredFeatures: [],
        requiredPermission: WORKSPACE_SETTINGS,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.usersSettingsTitle',
        route: ORG_USERS,
        requiredFeatures: [],
        requiredPermission: EDIT_USERS_ONE_TO_MANY,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.localizationTitle',
        route: ORG_LOCALIZATION,
        requiredFeatures: ['selfServeTranslationsEnabled'],
        requiredPermission: LOCALIZATION_ONE_TO_MANY,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.themesTitle',
        route: ORG_THEMES,
        requiredFeatures: ['themesEnabled', 'showsEnabled'],
        requiredPermission: INTEGRATIONS_ONE_TO_MANY,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.appIntegrationsTitle',
        route: ORG_INTEGRATIONS,
        requiredFeatures: ['showsEnabled'],
        requiredPermission: INTEGRATIONS_ONE_TO_MANY,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.themingTitle',
        route: ORG_ONE_TO_MANY_THEMES,
        requiredFeatures: ['oneToManyThemingEnabled', 'showsEnabled'],
        requiredPermission: INTEGRATIONS_ONE_TO_MANY,
        customFilterFunction: playerV2Filter,
        allowSuperAdmin: true,
      },
    ],
  },
];

export default ONE_TO_MANY_ROUTES;
